(function(){
	"use strict";

	angular
		.module('pwc.controllers')
		.controller('LogoutDialogController', LogoutDialogController);

	LogoutDialogController.$inject = ['$mdDialog'];

	function LogoutDialogController($mdDialog) {

		/* jshint validthis: true */
		var self = this;

		self.close = close;

		self.answer = answer;

		function close(){
			$mdDialog.hide();
		}

		function answer(text){
			$mdDialog.hide(text);
		}

	}

})();
